import React from 'react';
import T from 'prop-types';

import {
  Container,
  MainContainer,
  Logo,
  Title,
  Subtitle,
  BlueStrip,
} from '../styles';

import { withTranslation } from '../../../../core/i18n';

const ScreenerSessionSuccess = ({ phrases }) => (
  <Container>
    <Logo src="/images/playbook-logo.png" alt="Playbook" />
    <BlueStrip />
    <MainContainer>
      <Title>{phrases.response_recorded_title}</Title>
      <Subtitle>{phrases.screener_survey_info_message}</Subtitle>
    </MainContainer>
  </Container>
);

ScreenerSessionSuccess.propTypes = {
  phrases: T.func,
};

ScreenerSessionSuccess.defaultProps = {
  phrases: {},
};

export default withTranslation(ScreenerSessionSuccess);
